module.exports = __webpack_public_path__ + "static/section_trailer-1d05cf43685566a5e6e9a00b021a3029.jpg";